import PropTypes from 'prop-types';

const stylePropType = PropTypes.objectOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number])
);

export default stylePropType;
